<script>
import { HorizontalBar, mixins } from "vue-chartjs";
import chartMixins from "./chartMixin";

const { reactiveProp } = mixins;
export default {
	extends: HorizontalBar,
	mixins: [chartMixins, reactiveProp],
	props: {},
	data() {
		return {
			dataset: []
		};
	},
	computed: {
		options() {
			const MaxRange = Math.max(...this.dataset);
			return {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					display: false,
					labels: {
						fontSize: 13
					}
				},
				scales: {
					yAxes: [
						{
							ticks: {
								fontSize: 13,
								autoSkip: false
							}
						}
					],
					xAxes: [
						{
							gridLines: {
								drawOnChartArea: false
							},
							ticks: {
								display: true,
								// stepSize: 1,
								// beginAtZero: true, // minimum value will be 0.
								// suggestedMax: MaxRange + 1,
								stepSize: MaxRange <= 100 ? 10 : MaxRange >= 500 ? 200 : 50
							}
						}
					]
				},
				tooltips: {
					enabled: this.showTooltip,
					callbacks: {
						title: (tooltipItem, data) => {
							return data["labels"][tooltipItem[0]["index"]];
						},
						label: (tooltipItem, graphData) => {
							const { data } = graphData.datasets[0];
							return `${data[tooltipItem.index]}${this.prependTooltip}`;
						}
					}
				}
			};
		}
	},
	mounted() {
		this.dataset = this.chartData.datasets[0].data || [];
		this.renderChart(this.chartData, this.options);
	}
};
</script>
